module.exports = __webpack_public_path__ + "img/mobile.473b1c63.png";